import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=9a1ddc2c&"
import script from "./PopupMenu.vue?vue&type=script&lang=ts&"
export * from "./PopupMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=9a1ddc2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports